import { FormControl, MenuItem, Select } from "@mui/material";
import { actions, selectors } from "../../redux/localizations";
import { useDispatch, useSelector } from "react-redux";
import classes from "../../css/modules/navigation.module.scss";
import React from "react";
import { setMuiDataGridLocale } from "../../redux/muiLocale";

const locales = [
  {
    display: "NL",
    key: "nl",
  },
  {
    display: "EN",
    key: "en",
  },
];

export function LocaleSelect() {
  const { translations, lang } = useSelector(selectors.getAll);
  const dispatch = useDispatch();

  const handleChange = ({ target: { value } }) => {
    let action;

    if (value === lang) {
      return;
    }

    setMuiDataGridLocale(value);

    if (translations[value]) {
      action = actions.changeLang(value);
    } else {
      action = actions.fetchLang(value);
    }
    dispatch(action);
  };

  return (
    <FormControl variant="outlined" className={classes.langSelectFormControl} size="small">
      <Select value={lang} onChange={handleChange} type="secondary" data-testid="mn_menu_language">
        {locales.map((i) => (
          <MenuItem key={i.key} value={i.key} selected={i.key === lang} children={i.display} data-testid={"mn_menu_language_"+i.key} />
        ))}
      </Select>
    </FormControl>
  );
}
